<script>

var ajaxmixin = {
   methods: {
      ajaxtalk: function(params, url, postget, callback = null, token = null) {
          var XHR = new XMLHttpRequest();
          if (callback != null) {
             XHR.addEventListener('load', function(event) {
               callback(XHR.responseText);
             });
          }
          XHR.addEventListener('error', function(event) {
             alert('Oops! Something went wrong.');
          });
          if (postget == 'POST') {
             XHR.open(postget, url);
             XHR.setRequestHeader('X-CSRF-Token', token);
             XHR.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
             XHR.send(JSON.stringify(params));
          }
	  else {
	     url = url + '?' + Object.keys(params).map(function(key) {
               return key + '=' + params[key];
             }).join('&');
             XHR.open(postget, url);
             XHR.send(); 
          }
      },
      
      rmtextid: function(txt) {
         return(txt.replace(/^\d+\.\d+\.\d+\ ?/,''));
      } 
   }
};

export default ajaxmixin;

</script>